module.exports = __webpack_public_path__ + "image-f566e49e2f28.png";